import React from 'react'
import { useTranslation } from 'react-i18next'

const UsercentricsContainer: React.FC<{ settingsID?: string }> = ({ settingsID, children }) => {
    const { i18n } = useTranslation()
    const language = i18n.language

    React.useEffect(() => {
        if (settingsID && !document.getElementById('usercentrics-cmp')) {
            const script = document.createElement('script') as HTMLScriptElement & { 'data-version': string }
            if (process.env.NODE_ENV === 'development' || window.location.pathname.includes('localhost')) {
                script.setAttribute('data-version', 'preview')
            }
            script.id = 'usercentrics-cmp'
            script.src = 'https://app.usercentrics.eu/browser-ui/latest/loader.js'
            script.async = true
            script.setAttribute('data-settings-id', settingsID)
            script.setAttribute('data-language', language)
            document.head.appendChild(script)
            return () => {
                document.head.removeChild(script)
            }
        }
    }, [settingsID, language])

    return <>{children}</>
}

export default UsercentricsContainer
